import { PostEditorContextEnum } from '../../../models/post-editor';
import { PostEditorContextType } from '../../../providers/AppProvider';

export const isPostEditorActive = (postEditorContext: PostEditorContextType) =>
  ![PostEditorContextEnum.undefined, PostEditorContextEnum.import].includes(postEditorContext.type);
